<template>
    <footer class="w-full bg-white dark:bg-gray-800 dark:opacity-80" :style="{ direction: dir }">
        <div class="mx-auto border-t dark:border-yellow-500 border-gray-200 px-4 sm:px-6">

            <!-- Main Footer Content -->
            <div class="flex flex-col lg:flex-row items-center justify-between py-8 gap-8 lg:mx-10">

                <!-- Left Column: Logo -->
                <div class="flex items-center justify-center lg:justify-start ">

                    <img src="../../assets/logosham.svg" class="w-36" alt="Logo">

                </div>

                <!-- contact -->
                <div class="">
                    <!-- <p

                  >

                    {{ t('contactUs.title') }}
                  </p> -->

                    <ul :dir="textDirection" class="list-none p-1 dark:text-white">
                        <li>
                            <a href="mailto:infoshamnet@gmail.com" class="flex items-center mb-3">
                                <font-awesome-icon class="mx-1 text-sm" icon="fa-solid fa-envelope" />
                                <h5 class="text-black dark:text-white opacity-75 text-base leading-6">
                                    info@shamnet.com.sa
                                </h5>
                            </a>
                        </li>
                        <li>
                            <a href="tel:+966540290354" class="flex items-center mb-3">
                                <font-awesome-icon class="mx-1 text-sm" icon="fa-solid fa-phone" />
                                <h5 class="text-black dark:text-white text-base opacity-75 font-normal leading-6">
                                    {{ t('contactUs.phone') }}
                                </h5>
                            </a>
                        </li>
                        <li>
                            <a href="https://goo.gl/maps/your-map-link" target="_blank" class="flex items-center">
                                <font-awesome-icon class="mx-1 text-sm" icon="fa-solid fa-location-dot" />
                                <h5 class="text-black dark:text-white opacity-75 text-sm font-xs leading-6">
                                    {{ t('contactUs.location') }}
                                </h5>
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- Middle Column: Navigation Links -->
                <div class="flex flex-col md:flex-row lg:w-2/4 justify-center gap-8">

                    <div class="flex">
                        <!-- Products List -->
                        <div class="flex flex-col min-w-[200px]">

                            <ul class="space-y-4 text-center ">
                                <li>
                                    <RouterLink to="/"
                                        class="text-gray-600 hover:text-gray-900 dark:text-[#A9947E] dark:hover:text-[#b8b1ab]">
                                        {{ t('nav.home') }}
                                    </RouterLink>
                                </li>
                                <li>
                                    <RouterLink to="/service"
                                        class="text-gray-600 hover:text-gray-900 dark:text-[#A9947E] dark:hover:text-[#b8b1ab]">
                                        {{ t('nav.services') }}
                                    </RouterLink>
                                </li>
                                <li>
                                    <RouterLink to="/about"
                                        class="text-gray-600 hover:text-gray-900 dark:text-[#A9947E] dark:hover:text-[#b8b1ab]">
                                        {{ t('nav.about') }}
                                    </RouterLink>
                                </li>
                            </ul>
                        </div>

                        <!-- Resources List -->
                        <div class="flex flex-col  justify-center min-w-[150px]">

                            <ul class="space-y-4 text-center ">
                                <li>
                                    <RouterLink to="/news"
                                        class="text-gray-600 hover:text-gray-900 dark:text-[#A9947E] dark:hover:text-[#b8b1ab]">
                                        {{ t('nav.news') }}
                                    </RouterLink>
                                </li>
                                <li>
                                    <RouterLink to="/projects"
                                        class="text-gray-600 hover:text-gray-900 dark:text-[#A9947E] dark:hover:text-[#b8b1ab]">
                                        {{ t('nav.projects') }}
                                    </RouterLink>
                                </li>
                                <li>
                                    <RouterLink to="/contact"
                                        class="text-gray-600 hover:text-gray-900 dark:text-[#A9947E] dark:hover:text-[#b8b1ab]">
                                        {{ t('nav.contact') }}
                                    </RouterLink>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="flex flex-col justify-center min-w-[200px]">
                        <!-- زر التثبيت -->
                        <!-- Install Button -->
                        <div class="flex flex-col items-center">
                            <button @click.prevent="handleInstallClick"
                                class="inline-flex items-center px-6 py-2 rounded-lg shadow-2xl bg-primary text-white">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                    class="fill-current w-6 h-6 mr-2">
                                    <path
                                        d="M5.416 2.328L12.936 10.158C13.133 10.363 13.459 10.363 13.656 10.158L15.18 8.574C15.406 8.339 15.354 7.957 15.07 7.797C11.137 5.572 6.262 2.811 5.416 2.328zM3.141 2.848C3.056 3.046 3 3.263 3 3.504V20.592C3 20.789 3.044 20.971 3.109 21.141L11.576 12.324C11.762 12.131 11.762 11.827 11.576 11.633L3.141 2.848zM17.443 9.258C17.335 9.273 17.233 9.324 17.154 9.406L15.016 11.633C14.83 11.826 14.83 12.13 15.016 12.324L17.135 14.529C17.293 14.694 17.546 14.729 17.744 14.617C19.227 13.777 20.227 13.213 20.226 13.213C20.726 12.91 21.007 12.444 21 11.936C20.992 11.44 20.703 10.982 20.225 10.711C20.164 10.677 19.188 10.124 17.764 9.318C17.664 9.262 17.551 9.243 17.443 9.258zM13.297 13.645C13.166 13.645 13.034 13.696 12.936 13.799L5.475 21.566C6.757 20.837 11.329 18.25 15.051 16.143C15.335 15.982 15.386 15.599 15.16 15.363L13.656 13.799C13.558 13.696 13.428 13.645 13.297 13.645z"
                                        fill="#ffffff" />
                                </svg>
                                <span class="flex flex-col items-start">
                                    <span class="text-sm">GET IT ON</span>
                                    <span class="font-semibold">Direct Link</span>
                                </span>
                            </button>
                            <!-- iOS Instructions -->
                            <div id="ios-instructions" style="display: none; margin-top: 10px;">
                                <p>To install this app on your iPhone:</p>
                                <ol class="text-left">
                                    <li>Open the app in Safari.</li>
                                    <li>Tap the <strong>Share</strong> button.</li>
                                    <li>Select <strong>Add to Home Screen</strong>.</li>
                                </ol>
                            </div>
                        </div>

                    </div>

                </div>


                <!-- Right Column: Install Button & Map -->
                <div class="flex flex-col items-center lg:items-end lg:w-1/4 gap-4">



                    <!-- الخريطة -->
                    <div class="map-container">
                        <GoogleMapsWidget />
                    </div>

                </div>
            </div>

            <!-- Footer Bottom Section -->
            <div class="py-6 border-t dark:border-yellow-500 border-gray-200">
                <div class="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-0 lg:mx-20">

                    <span class="text-sm text-gray-500 dark:text-gray-300">{{ t('footer.copyright') }}</span>

                    <span class="flex gap-1 text-sm text-gray-500 dark:text-gray-300">
                        {{ t('footer.powered') }}
                        <a href="https://plateau.media/" target="_blank" class="gradient-text flex items-center">
                            {{ t('footer.plateau') }}
                            <img src="/img/icons/icon.png" width="22px" alt="">
                        </a>
                    </span>

                    <div class="flex space-x-4">
                        <SocialMediaComponent />
                        <a href="https://wa.me/+966504451484" target="_blank" class="social dark:bg-white">
                            <font-awesome-icon class="text-white hover:text-secondaryDark dark:text-secondaryDark"
                                icon="fa-brands fa-whatsapp" />
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
    import {
        useI18n
    } from 'vue-i18n'
    import {
        computed
    } from 'vue'
    import SocialMediaComponent from '@/components/SocialMediaComponent.vue'
    import GoogleMapsWidget from '../GoogleMapsWidget.vue'
    import {
        useInstallPromptStore
    } from '@/stores/useInstallPromptStore.js'

    const {
        t,
        locale
    } = useI18n()
    const installPromptStore = useInstallPromptStore()
    const textDirection = computed(() => (locale.value === 'ar' ? 'ltr' : 'ltr'))
    const dir = computed(() => (locale.value === 'ar' ? 'ltr' : 'ltr'))

    function handleInstallClick() {
        const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (isIOS) {
            // Show instructions for iOS users
            alert(
                "To install this app on your iPhone:\n\n1. Open in Safari.\n2. Tap the Share button.\n3. Select 'Add to Home Screen'.");
        } else if (installPromptStore.deferredPrompt) {
            // Handle installation for Android and supported platforms
            installPromptStore.deferredPrompt.prompt();
            installPromptStore.deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('تم قبول التثبيت');
                } else {
                    console.log('تم رفض التثبيت');
                }
                installPromptStore.clearDeferredPrompt();
            });
        } else {
            console.log('No installation prompt available');
        }
    }
</script>

<style scoped>
    .footer {
        direction: ltr !important;
    }

    .map-container {
        position: relative;
        width: 200px;
        border: 2px solid #B99269;
        /* Golden border */
        border-radius: 8px;
        /* Rounded corners */
        overflow: hidden;
        max-width: 400px;
        /* Fixed max width for the map */
        margin: auto;
        /* Center map in its container */
    }

    .gradient-text {
        background: linear-gradient(90deg, #eb2952, #141823);
        /* Gradient colors */
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        /* Make text transparent to show gradient */
    }

    .social {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        background-color: #374151;
    }

    .social:hover {
        background-color: #dcdbe2;
        color: #000;
        border: 1px solid #000;
    }

    @media (max-width: 768px) {
        .map-container {
            max-width: 100%;
        }
    }
</style>
